import type OriginTracing from '@atlassiansox/origin-tracing';

const getConfluenceEditorUrl = (spaceKey: string | null, parentPageId: string | null) => {
	if (spaceKey !== null && typeof spaceKey !== 'undefined') {
		const parentPageSection =
			parentPageId !== null && typeof parentPageId !== 'undefined' ? '/pages/' + parentPageId : '';
		return `/wiki/spaces/${spaceKey}${parentPageSection}`;
	} else {
		return '/wiki';
	}
};

export const getCrossJoinConfluenceEditorUrl = (
	origin: OriginTracing | null,
	spaceKey: string | null,
	parentPageId: string | null,
) => {
	const destUrl = getConfluenceEditorUrl(spaceKey, parentPageId);
	const identityParams = new URLSearchParams({
		'dest-url': origin ? origin.addToUrl(destUrl) : destUrl, // TODO JOIN-55 atlOrigin gets clobbered by identity even when added to the dest-url. Maybe use a custom query param.
		application: 'confluence',
		'permission-violation': 'true', // this forces JSS not to attempt to redirect to dest-url
	});
	return `/login?${identityParams.toString()}`;
};
